<template>
  <div id = 'profile' class = 'container-fluid text-white animated fadeIn'>
    <!-- <h1 class = 'text-left'>
      <strong>
        Erik Jackson
      </strong>
    </h1> -->

    <div id = 'profileBody' class = 'p-3'>
      <img id = 'profPic' class = 'float-left animated pulse mr-5 rounded' src = '/static/imgs/profpic.jpg'/>
      <p class = 'text-left mx-5'>
        Erik Jackson is a designer and full stack web developer from Saint Paul, Minnesota. 
        He is a graduate of the full stack web development program at University of Minnesota's 
        College of Continuing education, and is well-versed in both front and back end development.
      </p>

      <p class = 'text-left mx-5'>
        When not working on web development projects, Erik enjoys biking (weather permitting!), 
        painting, gaming, and playing either guitar or piano.
      </p>

      <br />

      <h5 class = 'text-left'>
        <strong>
          Programming Proficiencies
        </strong>
      </h5>
      <div class= 'row text-left'>
        <div class = 'col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 proficiencyList'>
          <ul>
            <li>React</li>
            <li>Vue</li>
            <li>Javascript</li>
            <li>jQuery</li>
            <li>Node.JS</li>
            <li>Express.JS</li>
          </ul>
        </div>
        <div class = 'col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 proficiencyList'>
          <ul>
            <li>OAuth</li>
            <li>MySQL</li>
            <li>Sequelize</li>
            <li>MongoDB</li>
            <li>Mongoose</li>
            <li>Bootstrap</li>
          </ul>
        </div>
        <div class = 'col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 proficiencyList'>
          <ul>
            <li>Firebase</li>
            <li>Handlebars</li>
            <li>Adobe Creative Suite</li>
            <li>AJAX</li>
            <li>HTML</li>
            <li>CSS</li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import store from '@/globals'
export default {
  name: 'Profile',
  mounted () {
    store.commit('menu')
  },
  updated () {
    store.commit('menu')
  },
  data () {
    return {
      msg: 'This is the Profile Page!'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  color: #4ecdc4;
}
h5 {
  margin-bottom: 20px;
}

h1:hover {
  color: #ff6b6b;
}

p {
  font-size: 20px;
}

@media screen and (max-width: 768px){
  h1 {
    left: 20px;
    margin-top: 20px;
  }

  .proficiencyList {
    margin-top: -15px;
  }

  #profile {
    background-color: #292f36;
    min-height: 800px;
  }

  #profileBody {
    background-color: #f6f7eb;
    color: #292f36;
    min-height: 500px;
  }

  #profPic{
    width: 90%;
    height: auto;
    margin: 5%;
    max-width: 400px;
  }
}

@media screen and (min-width: 768px){
  #profile {
    background-color: #292f36;
    min-height: 800px;
  }

  #profileBody {
    background-color: #f6f7eb;
    color: #292f36;
    /* min-height: 500px; */
  }

  #profPic{
    width: 40%;
    height: auto;
    min-width: 400px;
  }
}

@media screen and (min-width: 992px){
  #profile {
    background-color: #292f36;
    min-height: 750px;
  }

  #profileBody {
    background-color: #f6f7eb;
    color: #292f36;
    min-height: 750px;
  }

  #profPic{
    width: 35%;
    height: auto;
    min-width: 450px
  }
}



</style>



// WEBPACK FOOTER //
// src/components/Profile.vue